import React, { Component } from "react";
/**
 * About National Remote Centre Component
 */
export default class AboutNRSC extends Component {
  render() {
    return (
      <div>
        {/* <Header/> */}
        <div
          style={{ padding: "15px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }}
          className="card"
        >
          <div className="card-body">
            <h3 className="card-title" style={{ color: "#002171" }}>
              About NRSC
            </h3>
            <hr />
            {/* <div className="card-text">
              National Remote Sensing Centre (NRSC), is a full-fledged centres of ISRO. NRSC was functioning as an autonomous body called National Remote Sensing Agency (NRSA) under Department of Space (DOS) till August, 2008. The Centre is responsible for remote sensing satellite data acquisition and processing, data dissemination, aerial remote sensing and decision support for disaster management.
              <br /><br />
              National Remote Sensing Centre (NRSC) is an important segment of ISRO with the mandate of:<br />
              <ul>
                <li>Providing Earth observation (EO) Data from space and aerial platforms</li>
                <li> Develop technologies &amp; applications for Natural Resources Management</li>
                <li> To Provide support for monitoring and Management of Disaster</li>
                <li> Capacity building for utilization of EO data</li>
              </ul>
              The Activities of the Centre includes:
              <ol type='1'>
                <li>Planning, Acquisition, Processing and Dissemination of satellite data from various Indian &amp; foreign satellites</li>
                <li>Extending services to set up ground stations and processing facilities</li>
                <li>Carrying out Aerial Surveys and Large Scaling Mapping applications</li>
                <li>Providing Geospatial solutions to users</li>
                <li>Extending a 24X7 service to support disaster monitoring and management</li>
                <li>Outreach through training, workshops, student projects &amp; promotional activities related to remote sensing applications at regional and national level</li>
              </ol>
            </div> */}
            <div clasName="card-text">
              National Remote Sensing Centre (NRSC) is one of the primary
              centres of Indian Space Research Organisation (ISRO), Department
              of Space (DOS). NRSC has the mandate for establishment of ground
              stations for receiving satellite data, generation of data
              products, dissemination to the users, development of techniques
              for remote sensing applications including disaster management
              support, geospatial services for good governance and capacity
              building for professionals, faculty and students.
              <br />
              <br />
              NRSC operates through multiple campuses to meet national and
              regional remote sensing data and applications needs of the
              country.
              <ul>
                <li>
                  Main Campus at Balanagar,Hyderabad for Administration, Remote
                  Sensing Applications and Aerial Services{" "}
                </li>
                <li>
                  The Campus at Shadnagar for Satellite Data Reception, Data
                  Processing and Dissemination, Earth and Climate Studies and
                  Disaster Management Support
                </li>
                <li>
                  Five Regional Centres at Sector 9,KBHB in Jodhpur (Regional
                  Centre-West), Sadhiknagar at New Delhi (Regional
                  Centre-North), New Salt Lake City in Kolkata (Regional
                  Centre-East), Amaravathy Road in Nagpur (Regional
                  Centre-Central), Karthik Nagar in Bangalore (Regional
                  Centre-South) for promoting remote sensing applications for
                  various states.
                </li>
                <li>
                  Outreach facility at Jeedimetla in Hyderabad for providing
                  training for professionals, faculty and students and for
                  general outreach.
                </li>
                <li>
                  Aircraft operations facility at Begumpet Airport, Hyderabad
                </li>
              </ul>
              <p style={{ textAlign: "right" }}>
                {" "}
                <a
                  href="https://www.nrsc.gov.in/Aboutus_NRSC"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "underline" }}
                  target="_blank"
                >
                  Source
                </a>{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </p>
            </div>
          </div>
        </div>
        {/* <Footer/> */}
      </div>
    );
  }
}
